module.exports = __webpack_public_path__ + "img/styrianner-header-img-v2.d7e55071.jpg";